import { onValue, ref, set } from "firebase/database";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../..";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export const UpdateSwitch = () => {
  const { switchID } = useParams();
  const [user, setUser] = useState({});
  const [newRole, setNewRole] = useState("");
  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && switchID === currentUser.uid) {
        alert("Вы не можете изменить роль своего собственного аккаунта!");
        navigate("/switch");
      }
    });
  }, [switchID]);

  useEffect(() => {
    const usersRef = ref(db, `users/${switchID}`);
    onValue(usersRef, (snapshot) => {
      const userData = snapshot.val();
      setUser(userData);
      setNewRole(userData.role);
    });
  }, [switchID]);

  const handleRoleChange = (e) => {
    setNewRole(e.target.value);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    set(ref(db, `users/${switchID}`), {
      ...user,
      role: newRole,
    });
    navigate("/switch");
  };

  return (
    <div className="aside-right__desc center">
      <div className="modal switch-modal">
        <form>
          <h2>Управление ролью пользователя</h2>
          <div className="modal__item">
            <label>
              Пользователь 
              <input
                className="readOnly"
                value={user.displayName}
                placeholder="Имя пользователя"
                readOnly
              />
            </label>
          </div>
          <div className="modal__item">
            <label>
              Email 
              <input
                className="readOnly"
                value={user.email}
                placeholder="Email пользователя"
                readOnly
              />
            </label>
          </div>
          <div className="modal__item">
            <label>
              Телефон 
              <input
                className="readOnly"
                value={user.phoneNumber}
                placeholder="Телефон пользователя"
                readOnly
              />
            </label>
          </div>
        </form>
        <div className="modal__item padding">
          <form className="flex justify margin modal__actions_btns" onSubmit={handleFormSubmit}>
            <select className="field-input pointer" value={newRole} onChange={handleRoleChange}>
              <option value="Инженер">Инженер</option>
              <option value="Диспетчер">Диспетчер</option>
              <option value="Директор">Директор</option>
            </select>
            <button className="modal__button btn-item" type="submit">Изменить роль</button>
          </form>
        </div>
      </div>
    </div>
  );
};